import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DataTable from "../../components/common/DataTable";
import CustomModal from "../../components/common/CustomModal";
import { DELETE_PRODUCTS_LIST, GET_clientCompanies, GET_PRODUCTS_LIST } from "../../services/apiRoutes"
import { genericPost } from '../../services/authServices';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomLoader from "../../components/common/CustomLoader";
import MessageBox from "../../components/common/CustomMessageBox";
import { AuthContext } from "../../context/AuthContext";
import CreateManageProducts from "./CreateMasters/CreateManageProducts";
import { genericGet } from "../../services/apiServices";
import { getProductsGroup, getUnitList } from "../../services/CommonServices";
import UpdateManageProducts from "./UpdateMaster/UpdateManageProducts";
import CustomMaster from "../common/CustomMaster";
import CustomDelete from '../common/CustomDeleteAlert';
import axios from "axios";


const title = "Manage Product";

const ManageProducts = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [clientCompanies, setClientCompanies] = useState([]);
    const [getAllProducts, setGetAllProducts] = useState([]);
    const [UnitList, setUnitList] = useState([]);
    const [productGroup, setProductGroup] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleUpdateClick = (productsId) => {
        setSelectedId(productsId);
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };


    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "productName", header: "product Name", tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 50
            },
            {
                accessorKey: "productsGroupName", header: "Products Group Name", tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 50
            },
            {
                accessorKey: "clientCompanyName", header: "Client Company", tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 50
            },
            {
                accessorKey: "hsn", header: "HSN", tableStyle: { textAlign: "center" }, size: 50
            },
            {
                accessorKey: "iupac", header: "IUPAC", tableStyle: { textAlign: "center" }, size: 50
            },
            {
                accessorKey: "casNo", header: "CAS No", tableStyle: { textAlign: "center" }, size: 50
            },
            {
                accessorKey: "dutyPersentage", header: "duty %", tableStyle: { textAlign: "center" }, size: 50
            },
            {
                accessorKey: "taxPersentage", header: "tax %", tableStyle: { textAlign: "center" }, size: 50
            },
            {
                accessorKey: "unitName", header: "Unit", tableStyle: { textAlign: "center" }, size: 50
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                            <IconButton onClick={() => handleUpdateClick(row.original.productsId)}>
                                <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                            </IconButton>
                            <IconButton
                                onClick={() => handleOpenDeleteAlert(row.original.productsId)}
                            >
                                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                            </IconButton>
                        </div>
                    </>

                ),
            },

        ],
        []
    );

    const getProductList = async () => {
        setLoading(true);
        try {
            const response = await genericPost(GET_PRODUCTS_LIST, {});

            if (response.data.success && response.data.productsList) {
                const productData = response.data.productsList.map((product, index) => ({
                    productsId: product.productsId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    userId: product.userId || '',
                    companyId: product.companyId || '',
                    productName: product.productName || '',
                    dutyPersentage: product.dutyPersentage ? `${product.dutyPersentage}%` : '',
                    taxPersentage: product.taxPersentage ? `${product.taxPersentage}%` : '',
                    clientCompanyName: product.clientCompany?.clientCompanyName || '',
                    productsGroupName: product.productsGroup?.productsGroupName || '',
                    hsn: product.hsn || '',
                    iupac: product.iupac || '',
                    casNo: product.casNo || '',
                    createdAt: product.createdAt || '',
                    updatedAt: product.updatedAt || '',
                    unitName: product.productsUnit?.unitName || '',
                }));

                setGetAllProducts(productData);
            } else {
                setError('No products found');
            }
        } catch (error) {
            setError('Error fetching products');
            console.error('Error fetching products', error);
        } finally {
            setLoading(false);
        }
    };
    const fetchClientCompanies = async () => {
        setLoading(true);
        try {
            const response = await genericGet({ url: GET_clientCompanies });

            if (response.data.success && response.data.clientCompanies) {
                const clientCompanyData = response.data.clientCompanies.map((company) => ({
                    id: company.clientCompanyId || '',
                    title: company.clientCompanyName || '',

                }));
                setClientCompanies(clientCompanyData);
            } else {
                setError('No client companies found');
            }
        } catch (error) {
            setError('Error fetching client companies');
            console.error('Error fetching client companies', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (productsId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_PRODUCTS_LIST(productsId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                getProductList();
                setDeleteAlert(false);

            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    const getCommonData = async () => {
        const UnitListData = await getUnitList();
        setUnitList(UnitListData);

        const ProductGroup = await getProductsGroup();
        setProductGroup(ProductGroup);
    }

    useEffect(() => {
        getProductList()
        fetchClientCompanies()
        getCommonData()
    }, [token])

    const handleOpen = () => {
        setModal(true);
    };
    const handleClose = () => {
        setModal(false)
    }

    const defaultView = 'manageproducts';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <CustomLoader open={loading} />
                <DataTable
                    title={title}
                    columns={columns}
                    data={getAllProducts}
                    handleOpen={handleOpen}
                    buttonTitle="Add Product"
                />
                <CustomModal
                    modalStyles={{
                        maxHeight: '80vh',
                        top: "10%",
                    }}
                    open={modal} handleClose={handleClose}>
                    <CreateManageProducts
                        handleClose={handleClose}
                        clientCompanyList={clientCompanies}
                        fetchData={getProductList}
                        setMessage={setMessage}
                        UnitList={UnitList}
                        productGroup={productGroup}
                    />
                </CustomModal>
                <CustomModal
                    modalStyles={{
                        maxHeight: '80vh',
                        top: "10%",
                    }}
                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdateManageProducts
                        handleClose={handleCloseUpdate}
                        clientCompanyList={clientCompanies}
                        UnitList={UnitList}
                        productsId={selectedId}
                        fetchData={getProductList}
                        setMessage={setMessage}
                        productGroup={productGroup}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />

            </Box>
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </>
    );

    return (
        <CustomMaster
            defaultView={defaultView}
            mainContent={mainContent} />
    );
};
export default ManageProducts;

